/* AFIQ redesign · Contact (/pages/contact): reason hints, tier tokens, analytics.
   Loaded with defer by sections/afiq-contact-main + afiq-contact-faq (guarded, runs once), after afiq-shop.js. */
(function () {
  'use strict';
  if (window.__afiqContactInit || !window.AFIQ_UI) return;
  window.__afiqContactInit = true;
  /* Price/tier tokens, filled from live AFIQ data (never hard-coded). Same helper in afiq-contact/faq/filmroom/quiz/reviews.js. */
  function afiqFill(html) {
    var U = window.AFIQ_UI, A = window.AFIQ, P = U.P, $ = U.$, L = A.LADDER || [];
    var vols = U.VOLS, e = U.priceDecks(vols), top = L[L.length - 1] || { min: 0, pct: 0 };
    var cards = vols.reduce(function (s, id) { return s + (+P[id].cards || 54); }, 0);
    var ladder = function (unit) {
      return L.map(function (t, i) {
        var nx = L[i + 1], label = !nx ? t.min + ' or more' : (nx.min - 1 > t.min ? t.min + '–' + (nx.min - 1) + ' decks' : t.min + ' decks');
        var price = unit ? ' (' + $(A.unitCents(t.min)) + (i === 0 ? ' each' : '') + ')' : '';
        return label + ' ' + t.pct + '%' + (i === 0 ? ' off' : '') + price;
      }).join(', ');
    };
    var map = {
      elite_total: $(e.total), elite_full: $(e.full), elite_save: $(e.save), elite_cards: String(cards),
      ladder: ladder(true), ladder_short: ladder(false),
      top_min: String(top.min), top_pct: String(top.pct), top_unit: $(A.unitCents(top.min)),
      volumes: vols.map(function (d) { return '<b>' + U.esc(P[d].label) + ': ' + U.esc(P[d].title) + '</b>: ' + U.esc(P[d].hook); }).join('<br>'),
      fl5_hook: P.fl5 ? U.esc(P.fl5.hook) : ''
    };
    return String(html)
      .replace(/\{basics_discounted:([^|}]*)\|([^}]*)\}/g, function (m, yes, no) { return U.basicsDiscounted ? yes : no; })
      .replace(/\{pct_(\d+)\}/g, function (m, n) { return String(A.tier(+n).pct); })
      .replace(/\{unit_(\d+)\}/g, function (m, n) { return $(A.unitCents(+n)); })
      .replace(/\{([a-z0-9_]+)\}/g, function (m, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m; });
  }
  function afiqFillAll(root) {
    root = root || document;
    root.querySelectorAll('[data-afiq-tpl]').forEach(function (el) { el.innerHTML = afiqFill(el.getAttribute('data-afiq-tpl')); });
    root.querySelectorAll('[data-afiq-fill]').forEach(function (el) { el.innerHTML = afiqFill(el.innerHTML); });
  }

  afiqFillAll();
  var root = document.querySelector('[data-afiq-contact]');
  if (!root) return;
  var out = root.querySelector('[data-hint-out]'), group = root.querySelector('[data-reasons]');
  var setHint = function (input) { if (out && input) out.innerHTML = input.getAttribute('data-hint') || ''; };
  if (group) {
    setHint(group.querySelector('input:checked'));
    group.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'contact[Reason]') { setHint(e.target); AFIQ_UI.track('afiq_contact_reason', { reason: e.target.value }); }
    });
  }
  var form = root.querySelector('form');
  if (form) form.addEventListener('submit', function () {
    var r = form.querySelector('input[name="contact[Reason]"]:checked');
    AFIQ_UI.track('afiq_contact_submit', { reason: r ? r.value : '' });
  });
  if (root.querySelector('.form-ok')) AFIQ_UI.track('afiq_contact_sent', {});
})();
